/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useCallback, useState } from 'react'
import { Button, DatePicker, Input, InputNumber, Modal } from 'antd'
// import { testData, extendedData } from './Header'
import moment from 'moment'
import { Title } from 'core/screen-util'

import {
  MisoVerificationTestHeadersNumberMap,
  max4digit,
  title,
  updateDataRecord,
  calculateUCAP,
} from './Utils'

const CenterLabel = ({ children, style = {} }) => (
  <div style={{ display: 'grid', alignContent: 'center', ...style }}>
    {children}
  </div>
)

const RightLabel = ({ children, css = {} }) => (
  <div
    style={{
      display: 'grid',
      justifyContent: 'right',
      alignContent: 'center',
      ...css,
    }}
  >
    {children} :
  </div>
)
const LeftLabel = ({ children, style }) => (
  <div
    style={{
      ...style,
      display: 'grid',
      justifyContent: 'left',
      alignContent: 'center',
    }}
  >
    {children}
  </div>
)

const EmptyRow = _ => <div style={{ gridColumnEnd: 'span 10', height: 10 }} />

const MisoVerificationHistoryPanel = ({
  disabled = false,
  utilityNameMap = {},
  unitNameMap = {},
  ...props
}) => {
  const [data, setData] = useState({ ...props.data })

  const TextXefordComp = useCallback(
    ({ dataKey, data }) => (
      <Input
        key={dataKey}
        value={data.extendedData && data.extendedData[dataKey]}
        // value={data?.xefordData[dataKey]}
        // onChange={(e) => updateData(dataKey, e.target.value)}
        kayeName={dataKey}
        size="small"
        disabled
      />
    ),
    []
  )

  const TextComp = useCallback(
    ({ dataKey, disabled, data }) => (
      <InputNumber
        style={{ width: '100%' }}
        key={dataKey}
        value={data[dataKey]}
        // onChange={(e) => updateData(dataKey, e.target.value)}
        onChange={value =>
          updateDataRecord({ key: dataKey, value, data, setData })
        }
        kayeName={dataKey}
        disabled={disabled}
        size="small"
        max={MisoVerificationTestHeadersNumberMap[dataKey] || max4digit}
        min={(MisoVerificationTestHeadersNumberMap[dataKey] || max4digit) * -1}
      />
    ),
    []
  )

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns:
          '200px 100px 50px 200px 100px 50px 100px 50px 100px 50px',
        border: '1px solid black',
        gap: '5px',
        // marginTop: 100,
        padding: 10,
        margin: 5,
      }}
    >
      <div style={{ gridColumnEnd: 'span 4', textAlign: 'center' }}>
        <Title>
          {data.utility}-{utilityNameMap[data.utility]}
        </Title>
      </div>
      <div style={{ gridColumnEnd: 'span 6', textAlign: 'center' }}>
        <Title>
          {data.unit}-{unitNameMap[data.unitId]}{' '}
        </Title>
      </div>
      <div
        style={{
          gridColumnEnd: 'span 3',
          display: 'grid',
          textAlign: 'center',
        }}
      >
        <h4>Year : {data.year}</h4>
      </div>
      <div style={{ gridColumnEnd: 'span 3' }}>
        <h4> Season : {data.period === 'S' ? 'Summer' : data.period}</h4>
      </div>
      <div style={{ gridColumnEnd: 'span 4' }}>
        <h4>Test Index : {data.testIdx}</h4>
      </div>

      <EmptyRow />

      <RightLabel>Corrected Net Test Capacity</RightLabel>
      <TextComp data={data} dataKey="correctedNet" disabled />
      <LeftLabel>(MW)</LeftLabel>

      <RightLabel>Unit Standard</RightLabel>
      <CenterLabel style={{ gridColumnEnd: 'span 6' }}>
        {data.standard || 'MISO'}
      </CenterLabel>

      <RightLabel>Claimed Installed Capcacity</RightLabel>
      <TextComp data={data} dataKey="claimedInstalled" disabled />
      <LeftLabel>(MW)</LeftLabel>
      <RightLabel>Test Start-Date Time</RightLabel>
      <DatePicker
        style={{ gridColumnEnd: 'span 3' }}
        showTime
        value={data.testStartDate && moment(data.testStartDate)}
        format="MM/DD/YYYY HH:mm"
        size="small"
        disabled
      />
      <div style={{ gridColumnEnd: 'span 3' }} />

      <RightLabel>Difference</RightLabel>
      <TextComp data={data} dataKey="difference" disabled />
      <LeftLabel>(MW)</LeftLabel>
      <RightLabel>Test End-Date Time</RightLabel>
      <DatePicker
        style={{ gridColumnEnd: 'span 3' }}
        showTime
        value={data.testEndDate && moment(data.testEndDate)}
        format="MM/DD/YYYY HH:mm"
        size="small"
        disabled
      />
      <div style={{ gridColumnEnd: 'span 3' }} />
      <EmptyRow />
      <RightLabel>Gross</RightLabel>
      <TextComp data={data} dataKey="grossMW" />
      <div>(MW)</div>
      <div />
      <LeftLabel style={{ gridColumnEnd: 'span ' }}>Observed</LeftLabel>
      <div />
      <LeftLabel>Rated</LeftLabel>
      <div />
      <LeftLabel style={{ gridColumnEnd: 'span 2' }}>
        Correction (+ or -){' '}
      </LeftLabel>

      <RightLabel>Station Service </RightLabel>
      <TextComp data={data} dataKey="stationService" />
      <div>(MW)</div>
      <RightLabel>Dry Bulb Air Temperature</RightLabel>
      <TextComp data={data} dataKey="dryairTempObserved" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
      <TextComp data={data} dataKey="dryairTempRated" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
      <TextComp data={data} dataKey="airTempMwCorr" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>

      <RightLabel>Process Load</RightLabel>
      <TextComp data={data} dataKey="processLoadServed" />
      <div>(MW)</div>
      <RightLabel>Relative Humidity</RightLabel>
      <TextComp data={data} dataKey="relHumidityObserved" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(%)</LeftLabel>
      <TextComp data={data} dataKey="relHumidityRated" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(%)</LeftLabel>
      <TextComp data={data} dataKey="relHumidityMwCorr" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(%)</LeftLabel>

      <RightLabel>Net Test Capacity</RightLabel>
      <TextComp data={data} dataKey="netTestCapability" />
      <div>(MW)</div>
      <RightLabel>Cooling Water Temperature</RightLabel>
      <TextComp data={data} dataKey="cwaterTempObserved" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
      <TextComp data={data} dataKey="cwaterTempRated" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
      <TextComp data={data} dataKey="cwaterTempMwCorr" />
      <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>

      <EmptyRow />
      <RightLabel>Reactive Gen MVAR (+ or -)</RightLabel>
      <TextComp data={data} dataKey="reactiveGenMvar" />
      <div />
      <LeftLabel style={{ gridColumnEnd: 'span 7' }}> Note :</LeftLabel>

      <RightLabel>Total Power MVA</RightLabel>
      <TextComp data={data} dataKey="totalPowerMva" disabled />
      <div />
      <Input.TextArea
        maxLength={3999}
        value={data.note}
        // onChange={e => setData({ ...data, note: e.target.value })}
        rows={4}
        disabled={disabled}
        style={{
          gridColumnEnd: 'span 7',
          gridRowEnd: 'span 4',
        }}
      />

      <RightLabel>Power Factor</RightLabel>
      <TextComp data={data} dataKey="powerFactor" disabled />
      <div />
      <RightLabel>XEFORD</RightLabel>
      <TextXefordComp data={data} dataKey="xeford" />
      <div />
      <RightLabel>Potential UCAP</RightLabel>
      <Input size="small" value={calculateUCAP(data).ucapJTF || 0} disabled />
      <div />
    </div>
  )

  // return (
  //   <div
  //     style={{
  //       display: 'grid',
  //       gridTemplateColumns: '200px 100px 100px 150px 100px 50px',
  //       border: '1px solid black',
  //       gap: '5px',
  //       // marginTop: 100,
  //       padding: 10,
  //       margin: 5,
  //     }}
  //   >
  //     <div style={{ gridColumnEnd: 'span 3', textAlign: 'center' }}>
  //       <Title>
  //         {data.utility}-{utilityNameMap[data.utility]}
  //       </Title>
  //     </div>
  //     <div style={{ gridColumnEnd: 'span 3', textAlign: 'center' }}>
  //       <Title>
  //         {data.unit}-{unitNameMap[data.unitId]}{' '}
  //       </Title>
  //     </div>

  //     <div />
  //     <div style={{ gridColumnEnd: 'span 1' }}>
  //       <h4>Year : {data.year}</h4>
  //     </div>
  //     <div style={{ gridColumnEnd: 'span 2' }}>
  //       <h4> Season : {data.period === 'S' ? 'Summer' : data.period}</h4>
  //     </div>
  //     <div style={{ gridColumnEnd: 'span 2' }}>
  //       <h4>Test Index : {data.testIdx}</h4>
  //     </div>

  //     <EmptyRow />

  //     <RightLabel>Corrected Net Test Capacity</RightLabel>
  //     <TextComp data={data} dataKey="correctedNet" disabled />
  //     <LeftLabel>(MW)</LeftLabel>
  //     <RightLabel>Unit Standard</RightLabel>
  //     <CenterLabel>{data.standard || 'MISO'}</CenterLabel>
  //     <div />

  //     <RightLabel>Claimed Installed Capcacity</RightLabel>
  //     <TextComp data={data} dataKey="claimedInstalled" disabled />
  //     <LeftLabel>(MW)</LeftLabel>
  //     <RightLabel>Test Start-Date Time</RightLabel>
  //     <DatePicker
  //       style={{ gridColumnEnd: 'span 2' }}
  //       showTime
  //       value={data.testStartDate && moment(data.testStartDate)}
  //       format="MM/DD/YYYY HH:mm"
  //       size="small"
  //       disabled
  //     />

  //     <RightLabel>Difference</RightLabel>
  //     <TextComp data={data} dataKey="difference" disabled />
  //     <LeftLabel>(MW)</LeftLabel>
  //     <RightLabel>Test End-Date Time</RightLabel>
  //     <DatePicker
  //       style={{ gridColumnEnd: 'span 2' }}
  //       showTime
  //       value={data.testEndDate && moment(data.testEndDate)}
  //       format="MM/DD/YYYY HH:mm"
  //       size="small"
  //       disabled
  //     />

  //     <EmptyRow />

  //     <RightLabel>Gross (MW)</RightLabel>
  //     <TextComp data={data} dataKey="grossMW" />
  //     <div
  //       style={{
  //         gridColumnEnd: 'span 4',
  //         gridRowEnd: 'span 4',
  //         // border: '1px solid gray',
  //         display: 'grid',
  //         gridTemplateColumns: '200px 100px 20px 100px 20px 100px 20px',
  //         gap: 5,
  //       }}
  //     >
  //       <div />
  //       <LeftLabel>Observed</LeftLabel>
  //       <div />
  //       <LeftLabel>Rated</LeftLabel>
  //       <div />
  //       <LeftLabel style={{ gridColumnEnd: 'span 2' }}>
  //         Correction (+ or -){' '}
  //       </LeftLabel>

  //       <RightLabel>Dry Bulb Air Temperature</RightLabel>
  //       <TextComp data={data} dataKey="dryairTempObserved" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
  //       <TextComp data={data} dataKey="dryairTempRated" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
  //       <TextComp data={data} dataKey="airTempMwCorr" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>

  //       <RightLabel>Relative Humidity</RightLabel>
  //       <TextComp data={data} dataKey="relHumidityObserved" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(%)</LeftLabel>
  //       <TextComp data={data} dataKey="relHumidityRated" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(%)</LeftLabel>
  //       <TextComp data={data} dataKey="relHumidityMwCorr" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(%)</LeftLabel>

  //       <RightLabel>Cooling Water Temperature</RightLabel>
  //       <TextComp data={data} dataKey="cwaterTempObserved" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
  //       <TextComp data={data} dataKey="cwaterTempRated" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
  //       <TextComp data={data} dataKey="cwaterTempMwCorr" />
  //       <LeftLabel style={{ gridColumnEnd: 'span 1' }}>(F)</LeftLabel>
  //     </div>
  //     <RightLabel>Station Service </RightLabel>
  //     <TextComp data={data} dataKey="stationService" />
  //     <RightLabel>Process Load (MW)</RightLabel>
  //     <TextComp data={data} dataKey="processLoadServed" />
  //     <RightLabel>Net Test Capacity (MW)</RightLabel>
  //     <TextComp data={data} dataKey="netTestCapability" />

  //     <EmptyRow />
  //     <RightLabel>Reactive Gen MVAR (+ or -)</RightLabel>
  //     <TextComp data={data} dataKey="reactiveGenMvar" />
  //     <div style={{ gridColumnEnd: 'span 4', gridRowEnd: 'span 5' }}>
  //       <div
  //         css={{
  //           display: 'grid',
  //           // justifyContent: 'right',
  //           alignContent: 'left',
  //           width: 200,
  //           marginLeft: '50px',
  //         }}
  //       >
  //         Note :
  //       </div>
  //       <Input.TextArea
  //         maxLength={3999}
  //         value={data.note}
  //         onChange={e => setData({ ...data, note: e.target.value })}
  //         rows={4}
  //         disabled={disabled}
  //         style={{
  //           marginLeft: '50px',
  //           // gridColumnEnd: 'span 3',
  //           // gridRowEnd: 'span 5',
  //           // marginLeft: '5px',
  //         }}
  //       />
  //     </div>
  //     <RightLabel>Total Power MVA</RightLabel>
  //     <TextComp data={data} dataKey="totalPowerMva" disabled />

  //     <RightLabel>Power Factor</RightLabel>
  //     <TextComp data={data} dataKey="powerFactor" disabled />
  //     <RightLabel>XEFORD</RightLabel>
  //     <TextXefordComp  data={data} dataKey="xeford" />
  //     <RightLabel>Potential UCAP</RightLabel>
  //     <Input size="small" value={calculateUCAP(data).ucapJTF || 0} disabled />
  //   </div>
  // )
}

const MisoVerificationHistoryDialog = props => {
  return (
    <Modal
      maskClosable
      title={title}
      visible={props.visible}
      onOk={() => props.setVisible(false)}
      onCancel={() => props.setVisible(false)}
      destroyOnClose
      closable
      footer={
        <Button type="primary" onClick={() => props.setVisible(false)}>
          OK
        </Button>
      }
      style={{ top: 5, left: 5, width: '900px' }}
      width={1100}
      bodyStyle={{ padding: 5, margin: 5, top: 5 }}
    >
      <MisoVerificationHistoryPanel {...props} />
    </Modal>
  )
}

export default MisoVerificationHistoryDialog
